import Tippy from "@tippyjs/react";
import React from "react";

 const renderReliability = (toolTipContent: string, data: string): JSX.Element => (
  <Tippy
    theme="dnbtooltip"
    className="reliability-tag-tool-tip"
    content={toolTipContent}
  >
    <span className="reliability-tag">
      <span className="reliability-tag-icon"></span>
      <span className="reliability-tag-label">{data}</span>
    </span>
  </Tippy>
);

export default renderReliability;
